<template>
  <div class="connection-button-wrapper">
    <w-button-round
      v-if="isConnection"
      :text="text"
      style-type="dark"
      size="xsmall"
      @click="$emit('disconnect')"
    />
    <component
      :is="buttonComponents[snsType]"
      v-else
      class="connection-button"
      @success="$emit('connect', $event)"
    >
      {{ text }}
    </component>
  </div>
</template>

<script setup>
  import KakaoButton from '@/components/oauth/KakaoButton.vue'
  import NaverButton from '@/components/oauth/NaverButton.vue'
  import AppleButton from '@/components/oauth/AppleButton.vue'
  import FacebookButton from '@/components/oauth/FacebookButton.vue'
  import TidButton from '@/components/oauth/TidButton.vue'
  import WButtonRound from '@/components/button/WButtonRound.vue'

  const props = defineProps({
    text: {
      type: String,
      default: '연결하기',
    },
    snsType: {
      type: String,
      default: '',
    },
    snsId: {
      type: [String, Number],
      default: '',
    },
    isConnection: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['connect', 'disconnect'])

  const buttonComponents = {
    kakao: KakaoButton,
    naver: NaverButton,
    apple: AppleButton,
    facebook: FacebookButton,
    tid: TidButton,
  }
</script>

<style lang="scss" scoped>
  .connection-button-wrapper {
    flex: none;
    margin-left: 40px;
  }
  .connection-button {
    padding: 8px 14px;
    border-radius: 30px;
    font-size: 14px;
    color: #fff;
    line-height: 20px;
    background-color: #0050ff;
  }
</style>
